import { ArrowForward } from "@mui/icons-material";
import { IconButton, Paper, Stack, Typography, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router";

interface ProjectStatisticCardProps {
    href?: string;
    title: string;
    mainValue: string | number;
    subtitle: string;
}

export function ProjectStatisticCard({ href, title, mainValue, subtitle }: ProjectStatisticCardProps) {
    const { palette } = useTheme();

    return (
        <Stack component={Paper} variant="outlined" flexDirection="row" justifyContent="space-between" padding={2}>
            <Stack justifyContent="space-between">
                <Typography variant="h6" gutterBottom>
                    {title}
                </Typography>
                <div>
                    <Typography variant="h3">{mainValue}</Typography>
                    <Typography variant="body2">{subtitle}</Typography>
                </div>
            </Stack>

            {href !== undefined && (
                <IconButton
                    component={RouterLink}
                    to={href}
                    size="small"
                    sx={{
                        backgroundColor: palette.action.hover,
                        height: "1.2rem",
                        width: "1.2rem",
                        alignSelf: "flex-end",
                    }}
                >
                    <ArrowForward sx={{ color: palette.primary.main, heigth: "0.75rem", width: "0.75rem" }} />
                </IconButton>
            )}
        </Stack>
    );
}
